<template>
  <div class="page">
    <div class="main">
      <div class="header">
        <h2>{{visaData.visa.CountryName}}{{visaData.visa.VisaTitle}}{{visaData.visa.areaName}}</h2>
        <h4>签证类型：{{visaData.visa.Types.replace(/^,*(.*?),*$/, "$1")||''}}</h4>
        <p>产品价格：<span class="visa-price">￥{{visaData.visa.Price}}</span> </p>
      </div>
      <div class="content">
        <el-form ref="form" :model="personList" label-width="80px" size="mini">
          <div class="form-legent">
            <label>预计出行时间</label>
          </div>
          <div class="form-content">
            <el-form-item label="选择日期">
              <el-date-picker class=".el-input" style="width: 100%;" v-model="personList.txt_starttime" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="form-legent">
            <span><label>出行人信息</label><label style="color: red;">(共{{personList.sel_mancount}}人)</label></span>
            <div>
              <el-button type="primary" plain @click="addPerson" size="small">新增出行人</el-button>
            </div>
          </div>
          <div v-for="(item,index) in personList.persons" :key="index" class="form-content">
            <el-form-item label="姓名" prop="name">
              <el-input placeholder="请输入姓名" class=".el-input" v-model="item.name"></el-input>
            </el-form-item>
            <el-form-item label="旅客身份" prop="job">
              <el-select placeholder="请选择旅客身份" class=".el-input" v-model="item.job" size="small" style="width: 100%;">
                <el-option v-for="item in docList" :key="item.cn_name" :label="item.cn_name" :value="item.cn_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" plain @click="delPerson(index)" size="small">删除</el-button>
            </el-form-item>
          </div>
          <el-form-item style="margin-top: 20px">
            <el-button type="primary" size="large" @click="onSubmit">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        id: '',
        company: null,
        visaData: null,
        personList: {
          txt_starttime: "",
          sel_mancount: 1,
          persons: [{
            name: '',
            job: ''
          }]
        },
        docList: [],
      }
    },
    created() {
      let {
        id
      } = this.$route.query
      this.id = id;
      console.log(this.id)
      this.getCompany()
    },
    methods: {

      getVisaDetail() {
        var that = this
        var param = {
          id: that.id,
          companyId: that.company.Id
        }
        this.$api.VisaDetial(param).then(res => {
          console.log(res, 'visaDetail')
          this.visaData = res.data.data,
            this.docList = res.data.data.docList
        })
      },
      getCompany() {
        this.$api.GetCompany().then(res => {

          console.log(res, 'company')
          this.company = res.data.data
          this.getVisaDetail()
        }).catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          });
          console.log('%ccreate.vue line:93 object', 'color: #007acc;', err);
        })
      },
      addPerson() {
        this.personList.sel_mancount++
        this.personList.persons.push({
          name: '',
          job: ''
        })
      },

      onSubmit() {
        var that = this
        var param = {
          txt_visaid: that.id,
          txt_starttime: that.$moment(that.personList.txt_starttime).format("YYYY-MM-DD"),
          sel_mancount: that.personList.sel_mancount,

        }
        for (var i = 0; i < that.personList.persons.length; i++) {
          param['txt_surname' + (i + 1)] = that.personList.persons[i].name
          param['sel_mantype' + (i + 1)] = that.personList.persons[i].job
        }
        this.$api.PostOrder(param).then(res => {
          console.log(res, 'order')
          if (res.data.result) {
            console.log('%ccreate.vue line:126 object', 'color: #007acc;', res);
            that.$router.push({
              path: `/orderpay?orderId=${res.data.data}`,
            })
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      /**
       * 从personList中删除一个人。
       *
       * @param {number} index - 要删除的人的索引。
       * @return {void} 没有返回值。
       */
      delPerson(index) {
        this.personList.persons.splice(index, 1)
        this.personList.sel_mancount--
      }
    }
  }

</script>

<style lang="less" scoped>
  .page {
    width: 100%;

    .main {
      width: 860px;
      background: #fff;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      margin: 20px auto;
      padding-top: 30px;
      padding-left: 80px;
      padding-right: 80px;
    }

    .header {
      .visa-price {
        color: #ff8033;
        font-size: large;
      }

    }

    .content {
      .form-legent {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        label {
          color: #333;
        }

      }

      .form-content {
        margin-top: 20px;
        padding: 10px 10px 0px;
        border: 1px solid #ccc;
        border-radius: 5px;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/page/product/create.vue